const ATTRIBUTE_DATA_TYPES = [
  "String",
  "Boolean",
  "Date",
  "Number",
  "TextArea",
  "RichTextArea",
  "DateTime",
  "Email",
  "URL",
  "Auto",
  "Percentage",
  "Choice",
  "Currency",
  "User",
  "FileSelection",
  "MultiSelectChoice",
  "Label",
];

export { ATTRIBUTE_DATA_TYPES };
